var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_download"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 18,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 4,
    y: 20,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(-90 4 20)",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 18,
    y: 20,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(-90 18 20)",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9995 15.0001C11.7922 15.0016 11.5895 14.9387 11.4195 14.8201L7.41954 12.0001C6.97073 11.6817 6.86347 11.0605 7.17954 10.6101C7.33261 10.3916 7.56662 10.2434 7.82952 10.1983C8.09243 10.1532 8.36245 10.2151 8.57954 10.3701L11.9995 12.7601L15.3995 10.2001C15.8414 9.86869 16.4682 9.95823 16.7995 10.4001C17.1309 10.8419 17.0414 11.4687 16.5995 11.8001L12.5995 14.8001C12.4264 14.9299 12.2159 15.0001 11.9995 15.0001Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M12 13C11.4477 13 11 12.5523 11 12V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V12C13 12.5523 12.5523 13 12 13Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3accfceca73ca55f71fc74fe369eeb1f.svg";
export { ForwardRef as ReactComponent };